import * as angular from 'angular';

export const DirectivesModule = angular.module('app.directives', []);
